export default {
  mantra: {},
};
